// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .tooltip-inner {
  font-size: 150%;
}

.span-v-center {
  display: inline-flex;
  align-items: center;
}

select.form-control {
  height: unset !important;
}

.form-group {
  margin-bottom: 0;
}

.section-wrapper {
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #EDEDED;
}
@media (min-width: 768px) {
  .section-wrapper {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}
@media (min-width: 1024px) {
  .section-wrapper {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.section-wrapper .title-wr {
  margin-top: 8px;
  margin-bottom: 10px;
}
.section-wrapper .title-wr .title-text {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.section-wrapper .form-check-label,
.section-wrapper .form-check-label.btn {
  opacity: 0.8;
  color: #382738;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.46px;
  line-height: 18px;
}
.section-wrapper .details-wrapper {
  margin-top: 16px;
  padding: 20px 0;
  border-bottom: 1px solid #EDEDED;
  border-top: 1px solid #EDEDED;
  background-color: #FCFCFC;
}
.section-wrapper .details-wrapper .title {
  color: #3E0D42;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.39px;
  line-height: 15px;
}
.section-wrapper .details-wrapper .subtitle {
  color: #6B556C;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.69px;
  line-height: 22px;
}
.section-wrapper .details-wrapper .action-text {
  margin-left: 12px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.75px;
  line-height: 14px;
}
.section-wrapper .details-wrapper .item-wrapper {
  border: 1px solid lightgray;
  margin-bottom: 16px;
}
.section-wrapper .details-wrapper .item-wrapper .item {
  margin: 12px;
}
.section-wrapper .details-wrapper .item-wrapper .item-name {
  color: #3E0D42;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 16px;
}
.section-wrapper .details-wrapper .item-wrapper .item-info {
  opacity: 0.8;
  color: #382738;
  font-size: 11px;
  letter-spacing: 0.55px;
  line-height: 18px;
}

.buttons-wrap .btn {
  margin: 10px 0;
}

.request-footer .btn {
  height: 30px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: bold;
}
.request-footer .btn-outline-dark {
  color: #382738;
  border: 1px solid #EBE9EB;
  background-color: #FFFFFF;
}

.additional-notes {
  color: #3E0D42;
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 5px;
}

.notes-area {
  border: 1px solid #EBE9EB;
  border-radius: 3px;
  background-color: #FCFCFC;
  width: 100%;
  min-height: 180px;
  font-size: 12px;
}

.auto-margin {
  margin-top: auto;
  margin-bottom: auto;
}

.top20 {
  margin-top: 20px;
}

.content-offset {
  padding: 0 30px 0 30px;
}

.is-readonly {
  padding: 0;
  margin: 0;
  border: none;
}

.readonly-wrapper {
  padding: 20px 10px;
  border-top: 1px solid #EDEDED;
  border-bottom: 1px solid #EDEDED;
  background-color: #FCFCFC;
}
@media (min-width: 576px) {
  .readonly-wrapper {
    padding: 28px;
  }
}
.readonly-wrapper .details-wrapper {
  padding-bottom: 18px;
}
.readonly-wrapper .details-wrapper .subtitle {
  color: #6B556C;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.69px;
  line-height: 22px;
}
.readonly-wrapper .details-wrapper .item-wrapper {
  border: 1px solid #EBE9EB;
  border-radius: 3px;
  margin-bottom: 12px;
}
.readonly-wrapper .details-wrapper .item-wrapper .item {
  margin: 12px;
}
.readonly-wrapper .details-wrapper .item-wrapper .item-name {
  color: #3E0D42;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 16px;
}
.readonly-wrapper .details-wrapper .item-wrapper .item-info {
  opacity: 0.8;
  color: #382738;
  font-size: 11px;
  letter-spacing: 0.55px;
  line-height: 18px;
}

.btn-outline-blue {
  color: #085FFF !important;
  border: 1px solid #085FFF !important;
  background-color: #FFFFFF;
  text-transform: uppercase;
}
.btn-outline-blue:hover {
  background-color: #085FFF !important;
  border: 1px solid #085FFF !important;
  color: #FFFFFF !important;
}

.btn-reverse-blue {
  background-color: #085FFF !important;
  border: 1px solid #085FFF !important;
  color: #FFFFFF;
  text-transform: uppercase;
}
.btn-reverse-blue:hover {
  color: #085FFF !important;
  border: 1px solid #085FFF !important;
  background-color: #FFFFFF !important;
}

.item-wrapper-lfp {
  padding-bottom: 10px;
  border-bottom: 1px solid #EBE9EB !important;
}

.no-border {
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/club-interview-details/request-body/club-interview-request-body.component.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;AADF;;AAIA;EACI,oBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,wBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACE,iBAAA;EACA,oBAAA;EACA,gCAAA;AADF;AAGE;EALF;IAMI,iBAAA;IACA,oBAAA;EAAF;AACF;AAEE;EAVF;IAWI,iBAAA;IACA,oBAAA;EACF;AACF;AACE;EACE,eAAA;EACA,mBAAA;AACJ;AACI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AACN;AAGE;;EAEI,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AADN;AAIE;EACE,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,6BAAA;EACA,yBAAA;AAFJ;AAII;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAFN;AAKI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAHN;AAMI;EACE,iBAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AALN;AAQI;EACE,2BAAA;EACA,mBAAA;AANN;AAQM;EACE,YAAA;AANR;AASM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAPR;AAUM;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AARR;;AAeE;EACE,cAAA;AAZJ;;AAkBE;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAfJ;AAkBE;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAhBJ;;AAoBA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;AAlBJ;;AAqBA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AAlBJ;;AAqBA;EACI,gBAAA;EACA,mBAAA;AAlBJ;;AAqBA;EACI,gBAAA;AAlBJ;;AAqBA;EACI,sBAAA;AAlBJ;;AAqBA;EACI,UAAA;EACA,SAAA;EACA,YAAA;AAlBJ;;AAqBA;EACE,kBAAA;EACA,6BAAA;EACA,gCAAA;EACA,yBAAA;AAlBF;AAoBE;EANF;IAOI,aAAA;EAjBF;AACF;AAmBE;EACE,oBAAA;AAjBJ;AAoBI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAlBN;AAqBI;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;AAnBN;AAqBM;EACE,YAAA;AAnBR;AAsBM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AApBR;AAuBM;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AArBR;;AA0BA;EACE,yBAAA;EACA,oCAAA;EACA,yBAAA;EACA,yBAAA;AAvBF;AAyBE;EACE,oCAAA;EACA,oCAAA;EACA,yBAAA;AAvBJ;;AA0BA;EACE,oCAAA;EACA,oCAAA;EACA,cAAA;EACA,yBAAA;AAvBF;AAyBE;EACE,yBAAA;EACA,oCAAA;EACA,oCAAA;AAvBJ;;AA0BA;EACE,oBAAA;EACA,2CAAA;AAvBF;;AAyBA;EACE,uBAAA;AAtBF","sourcesContent":["@import '../../../../styles/global/colors';\n\n::ng-deep .tooltip-inner {\n  font-size: 150%;\n}\n\n.span-v-center {\n    display: inline-flex;\n    align-items: center;\n}\n\nselect.form-control {\n    height: unset !important;\n}\n\n.form-group {\n    margin-bottom: 0;\n}\n\n.section-wrapper {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #EDEDED;\n\n  @media (min-width: 768px) {\n    padding-top: 30px;\n    padding-bottom: 30px;\n  }\n\n  @media (min-width: 1024px) {\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n\n  .title-wr {\n    margin-top: 8px;\n    margin-bottom: 10px;\n\n    .title-text {\n      color: #3E0D42;\n      font-size: 14px;\n      font-weight: bold;\n      letter-spacing: 0.5px;\n      line-height: 18px;\n    }\n  }\n\n  .form-check-label,\n  .form-check-label.btn {\n      opacity: 0.8;\n      color: #382738;\n      font-size: 13px;\n      font-weight: bold;\n      letter-spacing: 0.46px;\n      line-height: 18px;\n  }\n\n  .details-wrapper {\n    margin-top: 16px;\n    padding: 20px 0;\n    border-bottom: 1px solid #EDEDED;\n    border-top: 1px solid #EDEDED;\n    background-color: #FCFCFC;\n\n    .title {\n      color: #3E0D42;\n      font-size: 11px;\n      font-weight: bold;\n      letter-spacing: 0.39px;\n      line-height: 15px;\n    }\n\n    .subtitle {\n      color: #6B556C;\n      font-size: 11px;\n      font-weight: bold;\n      letter-spacing: 0.69px;\n      line-height: 22px;\n    }\n\n    .action-text {\n      margin-left: 12px;\n      // color: #29BB73;\n      font-size: 12px;\n      font-weight: bold;\n      letter-spacing: 0.75px;\n      line-height: 14px;\n    }\n\n    .item-wrapper {\n      border: 1px solid lightgray;\n      margin-bottom: 16px;\n\n      .item {\n        margin: 12px;\n      }\n\n      .item-name {\n        color: #3E0D42;\n        font-size: 13px;\n        font-weight: bold;\n        letter-spacing: 0.5px;\n        line-height: 16px;\n      }\n\n      .item-info {\n        opacity: 0.8;\n        color: #382738;\n        font-size: 11px;\n        letter-spacing: 0.55px;\n        line-height: 18px;\n      }\n    }\n    \n  }\n}\n.buttons-wrap {\n  .btn {\n    margin: 10px 0;\n  }\n}\n.request-footer {\n  //margin-top: 22px;\n\n  .btn {\n    height: 30px;\n    border-radius: 3px;\n    font-size: 12px;\n    font-weight: bold;\n  }\n\n  .btn-outline-dark {\n    color: #382738;\n    border: 1px solid #EBE9EB;\n    background-color: #FFFFFF\n  }\n}\n\n.additional-notes {\n    color: #3E0D42;\n    font-size: 12px;\n    font-weight: bold;\n\n    margin-bottom: 5px;\n}\n\n.notes-area {\n    border: 1px solid #EBE9EB;\n    border-radius: 3px;\n    background-color: #FCFCFC;\n    width: 100%;\n    min-height: 180px;\n    font-size: 12px;\n}\n\n.auto-margin {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.top20 {\n    margin-top: 20px;\n}\n\n.content-offset {\n    padding: 0 30px 0 30px;\n}\n\n.is-readonly {\n    padding: 0;\n    margin: 0;\n    border: none;\n}\n\n.readonly-wrapper {\n  padding: 20px 10px;\n  border-top: 1px solid #EDEDED;\n  border-bottom: 1px solid #EDEDED;\n  background-color: #FCFCFC;\n\n  @media (min-width: 576px) {\n    padding: 28px;\n  }\n\n  .details-wrapper {\n    padding-bottom: 18px;\n\n\n    .subtitle {\n      color: #6B556C;\n      font-size: 11px;\n      font-weight: bold;\n      letter-spacing: 0.69px;\n      line-height: 22px;\n    }\n\n    .item-wrapper {\n      border: 1px solid #EBE9EB;\n      border-radius: 3px;\n      margin-bottom: 12px;\n\n      .item {\n        margin: 12px;\n      }\n\n      .item-name {\n        color: #3E0D42;\n        font-size: 13px;\n        font-weight: bold;\n        letter-spacing: 0.5px;\n        line-height: 16px;\n      }\n\n      .item-info {\n        opacity: 0.8;\n        color: #382738;\n        font-size: 11px;\n        letter-spacing: 0.55px;\n        line-height: 18px;\n      }\n    }\n  }\n}\n.btn-outline-blue  {\n  color: $interviews-blue !important;\n  border: 1px solid $interviews-blue !important;\n  background-color: #FFFFFF;\n  text-transform: uppercase;\n  \n  &:hover {\n    background-color: $interviews-blue !important;\n    border: 1px solid $interviews-blue !important;\n    color: #FFFFFF !important;\n  }\n}\n.btn-reverse-blue  {\n  background-color: $interviews-blue !important;\n  border: 1px solid $interviews-blue !important;\n  color: #FFFFFF;\n  text-transform: uppercase;\n  \n  &:hover {\n    color: $interviews-blue !important;\n    border: 1px solid $interviews-blue !important;\n    background-color: #FFFFFF !important;\n  }\n}\n.item-wrapper-lfp {\n  padding-bottom: 10px;\n  border-bottom: 1px solid #EBE9EB !important;\n}\n.no-border {\n  border: none !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
